export const useQuery = () => Object.fromEntries(new URLSearchParams(window.location.search));